import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { message } from "antd";
import { setShowAccountModal } from "../redux/features/footerMenuSlice.js";
import Layout from "../components/Layout/Layout";
import HeroSection from "../components/Home/HeroSection";
import MobileButtons from "../components/Home/MobileButtons";
import Products from "../components/Products";
import HomePopup from "../components/HomePopup";
import CancelIcon from "@mui/icons-material/Cancel";
import TelegramIcon from "@mui/icons-material/Telegram";
import Header from "../components/Header/Header";
import AccountModal from "../components/Header/AccountModal";
import website from "../website/data.js";
import "./css/Home.css";
import { getPublicBanners } from "../services/banner.service";

const Home = () => {
	const { user } = useSelector((state) => state.user);
	const { showAccountModal, showSearchModal } = useSelector((state) => state.footerMenu);
	const dispatch = useDispatch();
	const navigate = useNavigate();
    const [image, setImage] = useState("");
    const [pimg, setPimg] = useState("");
    const [link, setLink] = useState("");
    const [display, setDisplay] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [popupImageLink, setPopupImageLink] = useState(false);
    const [popupImageStatus, setPopupImageStatus] = useState(false);
    const [text, setText] = useState("");
    const [primaryBanners, setPrimaryBanners] = useState([]);
    const [popupBanner, setPopupBanner] = useState(null);
    const [showBannerPopup, setShowBannerPopup] = useState(false);

useEffect(() => {
    setTimeout(() => {
        setShowPopup(true);
    }, 1000);
}, []);

// Fetch banners and determine primary banners and popup banners
useEffect(() => {
    const fetchBanners = async () => {
        try {
            const res = await getPublicBanners();
            const list = Array.isArray(res?.data) ? res.data : [];
            if (list.length) {
                const sorted = [...list].sort((a, b) => (a?.priority || 0) - (b?.priority || 0));
                const popup = sorted.find((b) => (b?.type || '').toLowerCase() === 'pop up');
                const primaryBannersList = sorted.filter((b) => (b?.type || '').toLowerCase() === 'primary banner');
                setPrimaryBanners(primaryBannersList);
                setPopupBanner(popup || null);
            } else {
                setPrimaryBanners([]);
                setPopupBanner(null);
            }
        } catch (e) {
            setPrimaryBanners([]);
            setPopupBanner(null);
        }
    };
    fetchBanners();
}, []);

// Show popup when popup banner exists
useEffect(() => {
    if (popupBanner) {
        const t = setTimeout(() => setShowBannerPopup(true), 800);
        return () => clearTimeout(t);
    }
}, [popupBanner]);

	useEffect(() => {
		const handleBeforeUnload = (event) => {
			event.preventDefault();
			event.returnValue = "Are you sure you want quit?";
			localStorage.setItem("giveaway", "true");
		};
		window.addEventListener("beforeunload", handleBeforeUnload);
		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);

    const handleClosePopup = (e) => {
		e.stopPropagation();
		setShowPopup(false);
		localStorage.setItem("giveaway", "false");
	};

    const handleCloseBannerPopup = (e) => {
        e?.stopPropagation?.();
        setShowBannerPopup(false);
    };

	// ============== SLDIE TEXT

	// async function getSlideText() {
	// 	try {
	// 		const res = await apiClient.get("/banner/get-slide-text");
	// 		if (res.data.success) {
	// 			setText(res.data.data.text);
	// 		}
	// 	} catch (error) {
	// 		console.log(error);
	// 	}
	// }

	// useEffect(() => {
	// 	getSlideText();
	// }, []);

	useEffect(() => {
		if (
			user?.fname === null ||
			user?.email === null ||
			user?.email === "" ||
			user?.fname === ""
		) {
			if (isMobile) {
				dispatch(setShowAccountModal(true));
			} else {
				navigate("/my-account");
			}
		}
	}, [user?.fname, user?.email, isMobile, dispatch, navigate]);


	return (
		<Layout>
			<div className="main-home-container">
				{showPopup && display === "yes" && (
					<div
						className="popup-container d-none d-md-none d-lg-flex"
						onClick={(e) => handleClosePopup(e)}
					>
						<div>
							<CancelIcon
								onClick={(e) => handleClosePopup(e)}
								className="icon"
							/>
						</div>
						<img
							src={`${website.link}/${pimg}`}
							alt="popup-img"
							onClick={() => window.open(link, "_blank")}
						/>
					</div>
				)}
				<div className="d-block d-lg-none d-md-none">
					<Header />
				</div>
				<HeroSection primaryBanners={primaryBanners} />
				{/* Popup banner modal (once per session) */}
				{popupBanner && showBannerPopup && (
					<div
						className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
						style={{ background: 'rgba(0,0,0,0.6)', zIndex: 1050 }}
						onClick={handleCloseBannerPopup}
					>
						<div
							className="bg-transparent"
							onClick={(e) => e.stopPropagation()}
							style={{ maxWidth: 600, width: '90%' }}
						>
							<a href={popupBanner?.url?.startsWith('http') ? popupBanner.url : `https://${popupBanner?.url}` || '#'} target="_blank" rel="noreferrer" className="d-block w-100">
								<img
									src={popupBanner?.image}
									alt={popupBanner?.title || 'popup banner'}
									style={{ width: '100%', height: 'auto', borderRadius: 12 }}
									loading="lazy"
								/>
							</a>
							<button
								onClick={handleCloseBannerPopup}
								className="btn btn-light mt-2 w-100"
							>
								Close
							</button>
						</div>
					</div>
				)}
				<MobileButtons />
				<Products title={"Trending Games"} />
			</div>
			{!showAccountModal && (
				<HomePopup
					popupImageStatus={popupImageStatus}
					popupImageLink={popupImageLink}
					pimg={pimg}
				/>
			)}
			<AccountModal show={showAccountModal} user={user} />{" "}
			
			{/* Floating Telegram Support Button */}
			<div className="telegram-floating-btn">
				<a 
					href="https://t.me/CoinsUp01" 
					target="_blank" 
					rel="noopener noreferrer"
					className="telegram-float-link"
					title="Contact Support on Telegram"
				>
					<TelegramIcon className="telegram-float-icon" />
				</a>
			</div>
		</Layout>
	);
};

export default Home;
